import { Box, Button } from '@mui/material';

import { Dialog, GreenCheck } from '~/shared';

interface ICampaignDeleteCnpjExcelModal {
  message?: string | null;
  onCloseModal: () => void;
  handleUpdateAfterDelete: () => void;
}

export function CampaignDeleteCnpjExcelModal({
  message,
  onCloseModal,
  handleUpdateAfterDelete,
}: ICampaignDeleteCnpjExcelModal) {
  return (
    <Dialog
      title={message || 'CNPJ e CPF excluídos com sucesso'}
      withIcon={<GreenCheck size={70} />}
      open
      withCloseButton
      onClose={onCloseModal}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', mt: 4, gap: 2 }}>
        <Button
          size="large"
          variant="contained"
          sx={{ px: 3, py: 1.5 }}
          onClick={handleUpdateAfterDelete}
        >
          Ok
        </Button>
      </Box>
    </Dialog>
  );
}
